import React, { useEffect } from "react";
import { Column, FilterRow } from "devextreme-react/data-grid";
import DataGridBase from "Components/dataGridBase";
import locale from "./tableMethods.locale";
import ProgressOverlay from "Components/progressOverlay";
const renderObjectsCell = ({ data }) => {
    var _a;
    return (React.createElement("ul", { className: "no-text-decoration" }, (_a = data.Objects) === null || _a === void 0 ? void 0 : _a.map(({ Id, Name }) => (React.createElement("li", { key: Id, className: "text-overflow-ellipsis no-text-decoration", title: Name }, Name)))));
};
const renderGroupCell = ({ data }) => { var _a; return (_a = data.key) !== null && _a !== void 0 ? _a : "Без группы"; };
const renderAttributeCell = ({ data }) => {
    var _a;
    return (React.createElement("div", null, (_a = data.Objects) === null || _a === void 0 ? void 0 : _a.map(obj => {
        const { RequiredMethodAttributesFromTable } = obj;
        if (RequiredMethodAttributesFromTable && (RequiredMethodAttributesFromTable === null || RequiredMethodAttributesFromTable === void 0 ? void 0 : RequiredMethodAttributesFromTable.length) > 0) {
            return (React.createElement("ul", { key: obj.Id, className: "no-text-decoration" }, RequiredMethodAttributesFromTable.map(({ Item1, Item2 }) => (React.createElement(React.Fragment, { key: Item1 }, Item2.map(({ Key, Name }) => (React.createElement("li", { key: Key, className: "text-overflow-ellipsis no-text-decoration", title: `${Name} (${Key})` },
                Name,
                " (",
                Key,
                ")"))))))));
        }
        return null;
    })));
};
const filterBuilderFields = [
    {
        caption: locale.METHODS_NAME,
        dataField: "Name",
        dataType: "string"
    },
    {
        caption: locale.METHODS_ID,
        dataField: "Id",
        dataType: "string"
    },
    {
        caption: locale.METHODS_GROUP,
        dataField: "GroupName",
        dataType: "string"
    }
];
export default function SourceForm({ methodList, onInitialized, inProgress }) {
    useEffect(() => {
        onInitialized && onInitialized();
    }, []);
    return (React.createElement("div", { className: "grid-rows-auto-1fr stretched-to-fit panel-body-padding" },
        React.createElement("h2", { className: "font-bold pb-0_75" }, locale.METHODS_TITLE),
        React.createElement(ProgressOverlay, { show: inProgress },
            React.createElement("div", null,
                React.createElement(DataGridBase, { key: "SourceForm", keyExpr: "Id", data: methodList, cellTemplateRequired: false, allFilterPanelsOn: true, withPopupMessage: false, allowColumnResizing: true, minRowHeight: 36, gridWidth: "100%", filterBuilderFields: filterBuilderFields },
                    React.createElement(FilterRow, { visible: true }),
                    React.createElement(Column, { key: "Name", caption: locale.METHODS_NAME, dataField: "Name", dataType: "string", alignment: "left", width: "25%", editorOptions: { placeholder: locale.FILTER_PLACEHOLDER } }),
                    React.createElement(Column, { key: "Id", caption: locale.METHODS_ID, dataField: "Id", dataType: "string", alignment: "left", width: "25%", editorOptions: { placeholder: locale.FILTER_PLACEHOLDER } }),
                    React.createElement(Column, { key: "GroupName", groupIndex: 0, autoExpandGroup: false, dataField: "GroupName", dataType: "string", caption: locale.METHODS_GROUP, alignment: "left", editorOptions: { placeholder: locale.FILTER_PLACEHOLDER }, groupCellComponent: renderGroupCell }),
                    React.createElement(Column, { key: "Objects", caption: locale.OBJECT, dataType: "object", alignment: "left", width: "25%", cellRender: renderObjectsCell, allowFiltering: false, allowSorting: false, editorOptions: { placeholder: locale.FILTER_PLACEHOLDER } }),
                    React.createElement(Column, { key: "Objects_Attribute", caption: locale.OBJECT_ATTRIBUTE, dataType: "string", alignment: "left", width: "25%", allowFiltering: false, allowSorting: false, cellRender: renderAttributeCell, editorOptions: { placeholder: locale.FILTER_PLACEHOLDER } }))))));
}
